export default __webpack_public_path__ + "static/src/assets/images/icons/light/market_comment_icon_like_hit.png";